 
<app-sub-menu></app-sub-menu>
<router-outlet></router-outlet> 
 

